import React from "react";
import BsCol, { ColProps as BsColProps } from "reactstrap/lib/Col";

interface ColProps extends BsColProps {}

const Col = (props: ColProps) => {
    return <BsCol {...props} />;
};

export default Col;
